export enum SequenceTypeEnum {
	'APARTMENT' = 'apartment',
	'GARAGE' = 'garage',
	'GENERAL' = 'general',
	'CORE' = 'core',
	'LOBBY' = 'lobby',
	'STRUCTURE' = 'structure',
	'OFFICES' = 'offices',
	'HOTEL_ROOMS' = 'hotelRooms',
	'PRODUCTION_LINES' = 'productionLines',
	'COMMERCIALS' = 'commercials',
	'WET_ROOMS' = 'wetRooms',
	'MECHANICAL_ROOMS' = 'mechanicalRooms',
	'FACADE' = 'facade',
	'ELEVATORS' = 'elevators',
	'STAIRS' = 'stairs',
	'Kitchens' = 'kitchens',
	'Toilets' = 'toilets',
	/**
	 * Externally-owned work. The ONE value with no `AreaTypeEnum` twin, which is
	 * deliberate: an external sequence item's areas are named explicitly by the
	 * owning system (`areaIds`), not derived by matching `areaType` to the
	 * sequence type, so it must never resolve to a set of areas by type.
	 *
	 * That also ends the "strict subset of AreaTypeEnum" invariant the
	 * `sequenceType as unknown as AreaTypeEnum` casts relied on — see
	 * `SequenceItemService.getAreasBySequenceItemType`, which now refuses this
	 * value outright rather than asking ProjectConfig for areas of a type that
	 * cannot exist.
	 */
	'EXTERNAL' = 'external',
}
